<template>
<div class="chapter">
<div class="inner_page">
<p class="ind" style="margin-top:20px;">“Mr. President, I wish to speak today, not as a Massachusetts man, nor as a Northern man, but as an American…</p>
<p class="ind">“It is not to be denied that we live in the midst of strong agitations, and are surrounded by very considerable dangers to our institutions and government. The imprisoned winds are let loose. The East, the North, and the stormy South combine to throw the whole sea into commotion, to toss its billows to the sky, and disclose its profoundest depths. I speak today for the preservation of the Union…</p>
<p class="ind">“I hear with distress and anguish the word ‘secession,’ especially when it falls from the lips of those who are patriotic, and known to the country, and known all over the world, for their political services. Secession! Peaceable secession! Sir, your eyes and mine are never destined to see that miracle…</p>
<p class="ind">“I will not state what might produce the disruption of the Union; but, Sir, I see as plainly as I see the sun in heaven what that disruption itself must produce; I see that it must produce war.”</p>
<p class="right">March 7, 1850:</p>
<p class="right">Daniel Webster,</p>
<p class="right">to the United States Senate,</p>
<p class="right">in support of Henry Clay’s</p>
<p class="right">compromise bills</p>
<p class="right">on slavery.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6part.vue?02fac604